import css from 'styled-jsx/css';
import { pageWidth } from 'styles/css-constants';

export default css`
  .Spread__item--teaser {
    margin-bottom: 1.5rem;
  }

  .Spread__title {
    border-bottom-width: 1px;
  }

  .Spread__title h4 {
    color: #000;
    font-size: var(--baseFontSize);
    font-weight: 400;
    letter-spacing: 0.15em;
  }

  @media (min-width: 48rem) and (max-width: 63.99rem) {
    .Spread__items {
      flex-direction: row;
      flex-wrap: wrap;
    }

    .Spread__item--ad {
      flex: 0 0 100%;
      max-width: 100%;
    }

    .Spread__item--teaser {
      flex: 0 0 25%;
      max-width: 25%;
      padding: 0 0.75rem;
    }
  }

  @media (min-width: 64rem) {
    .Spread__item--teaser {
      flex: 0 0 25%;
    }
  }

  @supports (display: grid) {
    @media (min-width: 48rem) and (max-width: 63.99rem) {
      .Spread__item--teaser {
        max-width: none;
        padding: 0;
      }

      .Spread__item--teaser:nth-child(1) {
        grid-column-start: 2;
      }

      .Spread__items {
        display: grid;
        grid-column-gap: 1.5rem;
        grid-template-columns: 0fr repeat(4, 1fr) 0fr;
      }
    }

    @media (min-width: 48rem) {
      .Spread__item--teaser {
        margin-bottom: 0;
      }
    }

    @media (min-width: 64rem) {
      .Spread--everydayGrid {
        position: relative;
        display: flex;
        flex-direction: column;
      }

      .Spread__description,
      .Spread__title {
        align-self: stretch;
        margin: 0 calc((100% - ${pageWidth.large}) / 2) 1.5rem 0.75rem;
        max-width: ${pageWidth.large};
      }

      .Spread__item--teaser {
        grid-column-start: 2;
        width: 100%;
      }

      .Spread__item--teaser:nth-child(4) {
        border: none;
      }

      .Spread__items {
        display: grid;
        grid-template-columns:
          0.75rem
          calc((${pageWidth.large} * 0.42) - 0.75rem)
          minmax(0, calc((100% - ${pageWidth.large}) / 2));
        grid-template-rows: max-content max-content max-content max-content max-content;
        grid-template-rows: -webkit-max-content -webkit-max-content -webkit-max-content -webkit-max-content -webkit-max-content;
        grid-row-gap: 1rem;
        width: 100%;
      }

      .Spread__title {
        margin-bottom: 0.5rem;
        padding-bottom: 0;
        border-bottom: none;
      }
    }

    @media (min-width: 75rem) {
      .Spread__description,
      .Spread__title {
        margin: 0 calc((100% - ${pageWidth.midlarge}) / 2) 1.5rem 0.75rem;
        max-width: ${pageWidth.midlarge};
      }

      .Spread__item--teaser {
        width: 100%;
      }

      .Spread__items {
        grid-template-columns:
          0.75rem
          calc((${pageWidth.midlarge} * 0.42) - 0.75rem)
          minmax(0, calc((100% - ${pageWidth.midlarge}) / 2));
      }

      .Spread__title {
        margin-bottom: 0.5rem;
      }
    }
  }
`;
